"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconELearningSmartphone = /*#__PURE__*/
function (_Icon) {
  _inherits(IconELearningSmartphone, _Icon);
  function IconELearningSmartphone(props) {
    var _this;
    _classCallCheck(this, IconELearningSmartphone);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconELearningSmartphone).call(this, props));
    _this.name = 'IconELearningSmartphone';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "e-learning-smartphone_svg__group0"
    }, _react2.default.createElement("path", {
      className: "e-learning-smartphone_svg__path0",
      d: "M11.999 22.251a.75.75 0 01-.749-.746v-.014a.744.744 0 01.22-.522.744.744 0 01.567-.217.743.743 0 01.713.727v.032a.746.746 0 01-.718.737l-.031.002h-.002z"
    }), _react2.default.createElement("path", {
      className: "e-learning-smartphone_svg__path1",
      d: "M7.5 24.001a2.503 2.503 0 01-2.5-2.5v-19c0-1.379 1.121-2.5 2.5-2.5h9c1.378 0 2.5 1.121 2.5 2.5v19c0 1.378-1.122 2.5-2.5 2.5h-9zm-1.5-2.5c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-1.5H6v1.5zm12-2.5v-16.5c0-.827-.673-1.5-1.5-1.5h-9c-.827 0-1.5.673-1.5 1.5v16.5h12z"
    }), _react2.default.createElement("path", {
      className: "e-learning-smartphone_svg__path2",
      d: "M12 14.001c-.171 0-.339-.029-.499-.085l-1.833-.644A1.003 1.003 0 019 12.328v-1.8l-1-.333v1.807a.5.5 0 11-1-.001v-2.5a.48.48 0 01.056-.224.476.476 0 01.227-.224l.005-.003a.326.326 0 01.054-.025l4.342-1.446a1.02 1.02 0 01.632.001l3.986 1.329a.63.63 0 01.395.394.62.62 0 01-.033.476.62.62 0 01-.361.315L15 10.528v1.797a1 1 0 01-.666.943l-1.834.648a1.522 1.522 0 01-.5.085zm-2-1.673l1.833.645a.503.503 0 00.334.001L14 12.325v-1.464l-1.684.561a.991.991 0 01-.632 0L10 10.861v1.467zm2-1.854l2.918-.972L12 8.528 9.082 9.5l2.918.974zm0-1.946z"
    })));
    return _this;
  }
  return IconELearningSmartphone;
}(_Icon3.default);
exports.default = IconELearningSmartphone;